import CoBranding from './co-branding'

export default CoBranding
